import { api } from '@src/constants/api';
import { createMiddleware, Next } from '@src/utils';
import { backupsActions } from '@src/store/reducers/backupsReducer';

export const createBackupsMiddleware = (http: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [backupsActions.GET_BACKUPS]: async ({ payload }: any, next: Next) => {           
            const response = await http.post(`${restServiceUrl}Backup/GetBackups`, payload.data,{timeout: 600000 });
            const data = response.data;
            next({ type: backupsActions.SET_BACKUPS, payload: {backups: data} });
            return data;
        },

        [backupsActions.GET_BACKUPS_FOR_RESTORE]: async ({ payload }: any, next: Next) => {        
            const response = await http.post(`${restServiceUrl}Backup/GetBackupsForRestore`,payload.data,{timeout: 600000 });
            const data = response.data;
            next({ type: backupsActions.SET_BACKUPS_FOR_RESTORE, payload: {backupForRestore: data} });
            return data;
        },

        [backupsActions.GET_BACKUPS_ACTIONS]: async ({payload}: any,next: Next) => { 
            if(payload.data == undefined){
                payload.data = null;
            }          
            const response = await http.post(`${restServiceUrl}Environments/GetBackupActions`,payload.data,{timeout: 600000 });
            const data = response.data;
            next({ type: backupsActions.SET_BACKUPS_ACTIONS, payload: {backActions: data} });
            return data;
        },
        [backupsActions.GET_RESTORE_ACTIONS]: async ({payload},next: Next) => {   
            if(payload.data == undefined){
                payload.data = null;
            }           
            const response = await http.post(`${restServiceUrl}Environments/GetRestoreActions`,payload.data,{timeout: 600000 });
            const data = response.data;
            next({ type: backupsActions.SET_RESTORE_ACTIONS, payload: {restoreActions: data} });
            return data;
        },
        [backupsActions.GET_STORAGE_TYPES]: async (_: any,next: Next) => {           
            const response = await http.get(`${restServiceUrl}Projects/GetStorageTypes`,{timeout: 600000 });
            const data = response.data;
            next({ type: backupsActions.SET_STORAGE_TYPES, payload: {storageTypes: data} });
            return data;
        },
        
        [backupsActions.RESTORE_ENVIRONMENTS]: async ({ payload }: any /*, next: Next*/ ) => {   
        
            const response = await http.post(`${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.targetEnvId}/BackupId/${payload.backupId}/Force/${payload.force}/restoreDeployedPackagesOnly/${payload.restoreDeployedPackagesOnly}/RestoreEnvironment`, payload.data,{timeout: 600000 });
            const data = response.data;
            //next({ type: backupsActions.SET_BACKUPS, payload: data });
            return data;
        },
        
        [backupsActions.BACKUP_ENVIRONMENT]: async ({ payload }: any/*, next: Next*/) => {           
            //const response = await http.post(`${restServiceUrl}Projects/${payload.projectId}/Environments/${payload.targetEnvId}/BackupName/${payload.backupName}/ForceBackup/${payload.force}/BackupEnvironment`, payload.data,{timeout: 600000 });
            const response = await http.post(`${restServiceUrl}Environments/BackupEnvironment`, payload.data,{timeout: 600000 });
            const data = response.data;
            //next({ type: backupsActions.SET_BACKUPS, payload: data });
            return data;
        },
        
        [backupsActions.DELETE_BACKUP]: async ({ payload }: any) => {
            const response = await http.delete(`${restServiceUrl}Backup/${payload.backupId}/delete`);
            return response.data;
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/backups.middleware.ts